<template>
    <Layout>
      <div style="display: flex">
        <div
          style="width: 300px; flex: none; margin-right: 1.5rem; max-height: 80vh;min-height:800px"
          class="card overflow-auto"
        >
          <equipSearchTree
            @getDragCharts="getDragCharts" 
            :isShowMeasurement="true"
          />
        </div>
        <div
          style="
            width: calc(100% - 300px - 1.5rem);
            max-height: calc(100vh - 230px);
          "
        >
          <div class="d-flex resize-box h-100" style="overflow: auto">
            <div
              class="left-box h-100"
              style="width: 65%; margin-right: 10px; min-width: 820px"
            >
              <div class="card h-100">
                <div class="card-body" style="margin: 0; padding: 10px">
                  <div class="d-flex justify-content-end mb-3 me-3">
                    <b-button
                      style="
                        background: #2C404C;
                        display: flex;
                        align-items: center;
                      "
                      @click="getValueAnnotation"
                      type="button"
                      class="btn btn-primary m-2"
                      data-bs-toggle="modal"
                      data-bs-target="#valueSet"
                      ><i
                        class="ri-pencil-fill align-middle fs-15"
                        style="margin-right: 5px"
                      ></i
                      >{{this.$t('page.atlas-analysis.ChartAnnotation')}}</b-button
                    >
                    <b-button
                      style="
                        background: #2C404C;
                        display: flex;
                        align-items: center;
                      "
                      type="button"
                      class="btn btn-primary m-2"
                      @click="handleImageEditor()"
                    >
                      <i
                        class="ri-camera-fill align-middle fs-15"
                        style="margin-right: 5px"
                      ></i
                      >{{this.$t('page.atlas-analysis.DataSnapshots')}}
                    </b-button>
                  </div>
                  <div class="d-flex" style="height: calc(100% - 150px)">
                    <div
                      :style="{
                        height: '100%',
                        width: isCollapse ? 'calc(100% - 250px)' : '100%',
                        position: 'relative',
                      }"
                      id="chart_box"
                      @dragover="dragEnter($event)"
                      @dragleave="dragleave($event)"
                      @drop="drop(dragObj)"
                    >
                      <div
                        v-show="draglist.length == 0"
                        style="
                          position: absolute;
                          height: calc(100% + 150px);
                          width: 100%;
                          background: #f3f6f9;
                          top: -80px;
                          z-index: 999;
                          border: 3px #ccc dotted;
                          border-radius: 10px;
                          margin-top: 7px;
                          position: relative;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                        :class="[focusType && 'dotted_css']"
                      >
                        <img
                          style="
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                          "
                          src="./Cover.png"
                          alt=""
                        />
                        <div style="display: flex; align-items: center">
                          <img style="width:30px;height:30px" src="./Shape.png" alt="" />
                          <div
                            style="
                              font-weight: 500;
                              font-size: 19.8px;
                              line-height: 24px;
                              color: #0d0d11;
                              margin-left: 10px;
                            "
                          >
                            {{this.$t('page.atlas-analysis.SelectMeasurement')}}
                          </div>
                        </div>
                        <div style="position: absolute; bottom: 50px; left: 20px">
                          <div style="display: flex; align-items: center">

                          </div>
                          <div
                            class="mytext-gradient"
                            style="
                              margin-top: 20px;
                              width: 460px;
                              font-weight: 400;
                              font-size: 14px;
                              line-height: 16px;
                            "
                          >
                            {{this.$t('page.atlas-analysis.AITechnologyTool')}}
                          </div>
                        </div>
                      </div>
                      <div
                        v-show="draglist.length != 0"
                        id="monitor"
                        class="chart w-100"
                        style="height: calc(100vh - 400px)"
                      ></div>
                      <div
                        v-show="annotationVisible"
                        class="p-2"
                        :style="{
                          width: '350px',
                          height: '85px',
                          border: '1px solid rgba(0, 0, 0, 0.101961)',
                          boxShadow: '0px 1px 2px rgba(56, 65, 74, 0.14902)',
                          borderRadius: '4px',
                          background: ' #ffffff',
                          position: 'absolute',
                          top: annotationStyle.y + 'px',
                          left: annotationStyle.x + 10 + 'px',
                          zIndex: '999',
                        }"
                      >
                        <div
                          class="d-flex align-items-center justify-content-between w-100"
                          style="
                            border-bottom: 1px solid rgba(0, 0, 0, 0.0509804);
                            color: #878a99;
                          "
                        >
                          <div>
                            {{
                              valueAnnotationDataList[valueAnnotationDataIndex] &&
                              valueAnnotationDataList[valueAnnotationDataIndex]
                                .properties.name
                            }}{{this.$t('page.atlas-analysis.OfAnnotation')}}
                          </div>
                          <div class="d-flex align-items-center">
                            <i
                              class="ri-arrow-left-s-line"
                              @click="
                                () => {
                                  valueAnnotationDataIndex--;
                                  if (valueAnnotationDataIndex < 0) {
                                    valueAnnotationDataIndex = 0;
                                  }
                                }
                              "
                            ></i
                            >{{ valueAnnotationDataIndex + 1 }}/{{
                              valueAnnotationDataList.length
                            }}<i
                              class="ri-arrow-right-s-line"
                              @click="
                                () => {
                                  valueAnnotationDataIndex++;
                                  if (
                                    valueAnnotationDataIndex >
                                    valueAnnotationDataList.length - 1
                                  ) {
                                    valueAnnotationDataIndex =
                                      valueAnnotationDataList.length - 1;
                                  }
                                }
                              "
                            ></i>
                            <i
                              @click="delLocal"
                              style="
                                font-size: 20px;
                                color: #000;
                                cursor: pointer;
                              "
                              class="ri-close-fill ms-2"
                            ></i>
                          </div>
                        </div>
                        <div
                          style="height: 50px"
                          class="d-flex align-items-center justify-content-between"
                        >
                          <div>
                            {{
                              valueAnnotationDataList[valueAnnotationDataIndex] &&
                              valueAnnotationDataList[valueAnnotationDataIndex]
                                .properties.text
                            }}
                          </div>
                          <div>
                            <i
                              @click="
                                delLatestReports(
                                  valueAnnotationDataList[
                                    valueAnnotationDataIndex
                                  ]
                                )
                              "
                              class="ri-delete-bin-line me-3"
                              style="
                                line-height: 20px;
                                height: 20px;
                                cursor: pointer;
                              "
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-show="notesListData.length > 0 && draglist.length != 0"
                      style="margin-left: -2px; height: calc(100vh - 500px)"
                    >
                      <i
                        :class="[
                          isCollapse
                            ? 'ri-arrow-right-s-line'
                            : 'ri-arrow-left-s-line',
                        ]"
                        style="
                          font-size: 32px;
                          margin-left: -8px;
                          border-radius: 50%;
                          border: 1px solid #868282;
                        "
                        @click="handleIsCollapse()"
                      ></i>
                      <Notes
                        :notesList="notesListData"
                        v-show="isCollapse"
                        style="width: 250px"
                      ></Notes>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right-box h-100" style="width: 35%; min-width: 545px">
              <div class="w-100" style="height: calc(100% - 300px)">
                <selectedData
                  @delDragData="delDragData"
                  :draglist="draglist"
                  @staticSwitch="staticSwitch"
                  @dyThresholdSwitch="dyThresholdSwitch"
                  @getValueHealthData="updateValueHealthData"
                  @date="date"
                  v-model:daterange="daterange"
                  v-model:prePageNum="prePageNum"
                ></selectedData>
              </div>
              <div style="height: 300px">
                <dataScience style="height: 100%"></dataScience>
              </div>
            </div>
          </div>
          <ImageEditor
            v-model:isShowImageEditor="isShowImageEditor"
            v-if="isShowImageEditor"
            :imageUrl="imageUrl"
          ></ImageEditor>
        </div>
      </div>
      <div
        class="modal fade show"
        id="valueSet"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        role="dialog"
        aria-labelledby="valueSetLabel"
        aria-hidden="true"
        style="display: block; z-index: 999;"
        v-if="annotationShow"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header mb-3 fs-16">
              <div>
                {{this.$t('page.atlas-analysis.face')}}{{ valueAnnotationData.name }}
                {{
                  valueAnnotationData.time &&
                  moment(valueAnnotationData.time).format("YYYY-MM-DD HH:mm:ss")
                }}
                {{this.$t('page.atlas-analysis.OfAnnotation')}}
              </div>
              <div>
                <i
                  style="cursor: pointer"
                  class="ri-close-line"
                  @click="
                    () => {
                      annotationShow = false;
                    }
                  "
                ></i>
              </div>
            </div>
            <div class="modal-body text-start p-2 m-3 mb-2" style="width: 90%">
              <p>{{this.$t('page.atlas-analysis.describe')}}</p>
              <p>
                <textarea
                  v-model="valueAnnotationData.text"
                  class="form-control m-2"
                  :placeholder="this.$t('page.atlas-analysis.PleaseInput')"
                  rows="4"
                  maxlength="200"
                ></textarea>
              </p>
              <div style="display: flex; align-items: center">
                <div style="margin-right: 10px">{{this.$t('page.atlas-analysis.SelectPatternColor')}}</div>
                <el-color-picker
                  v-model="valueAnnotationData.color"
                  :predefine="[
                    '#219e9e',
                    '#c864bf',
                    '#ff653b',
                    '#3240a1',
                    '#434953',
                  ]"
                ></el-color-picker>
              </div>
            </div>
            <div class="modal-footer text-center p-2 justify-content-center">
              <a
                href="javascript:void(0);"
                class="btn fw-medium btn-light"
                @click="
                  () => {
                    annotationShow = false;
                  }
                "
                >{{this.$t('base.cancel')}}</a
              >
  
              <a
                href="javascript:void(0);"
                @click="setLatestReports"
                data-bs-dismiss="modal"
                class="btn btn-primary"
                >{{this.$t('base.done')}}</a
              >
            </div>
          </div>
        </div>
      </div>
      <MessageAlert
        :alertInfo="alertInfo"
        v-if="formValidataAlert"
      ></MessageAlert>
    </Layout>
  </template>
  
  <script>
  import { ElColorPicker } from "element-plus";
  import "element-plus/theme-chalk/el-color-picker.css";
  import "element-plus/es/components/color-picker/style/css";
  import Layout from "@/layouts/main.vue";
  import appConfig from "../../../app.config";
  import equipSearchTree from "../../components/equipSearchTree.vue";
  import Notes from "./notes.vue";
  import selectedData from "./selectedData.vue";
  import dataScience from "./dataScience.vue";
  import _ from "loadsh";
  import { spectrumEcharts } from "../../utils/chart";
  import ImageEditor from "@/components/image-editor";
  import * as echarts from "echarts";
  import MessageAlert from "@/components/common/MessageAlert";
  /* */ import { ElMessage } from "element-plus";
  import "element-plus/theme-chalk/el-message.css";
  import { valueFormatter1 } from "../../utils/common.js";
  import {
    getWindowTimeseries,
    // getRawTimeseries,
    getLatestReports,
    setLatestReports,
    delLatestReports,
    //   putLatestReports,
  } from "@/service/index";
  import moment from "moment";
  import qs from "qs";
  import i18n from "@/i18n";
  export default {
    page: {
      title: i18n.global.t('menu.intelligent-operation-maintenance.data-analysis'),
      meta: [{ tag: 0, name: "description", content: appConfig.description }],
    },
    components: {
      Layout,
      equipSearchTree,
      Notes,
      selectedData,
      dataScience,
      ImageEditor,
      MessageAlert,
      ElColorPicker,
    },
    data() {
      return {
        dataZoom: [
          {
            start: 0,
            end: 100,
          },
        ],
        isShowImageEditor: false,
        annotationShow: false,
        alertInfo: {
          variant: "danger",
          content: this.$t('page.atlas-analysis.SelectedRangeExceedsTheMaximumDataLimit'),
          icon: "ri-error-warning-line",
        },
        formValidataAlert: false,
        notesList: [
          {
            name: this.$t('page.atlas-analysis.1MillInputShaftAxialX'),
            lineColor: "rgba(80, 195, 230, 1)",
            createTime: "2022-09-08 16:00",
            textList: [
              this.$t('page.atlas-analysis.GenerateAlarm1111'),
              this.$t('page.atlas-analysis.GenerateAlarm2222'),
            ],
          },
          {
            name: this.$t('page.atlas-analysis.1MillInputShaftAxialY'),
            lineColor: "rgba(102, 145, 231, 1)",
            createTime: "2022-09-08 13:00",
            textList: [this.$t('page.atlas-analysis.GenerateAlarm1234')],
          },
        ],
        imageUrl: null,
        isCollapse: false,
        windowTimeseriesData: [],
        draglist: [],
        focusType: false,
        dragObj: {},
        valueAnnotationDataList: [],
        valueAnnotationDataIndex: 0,
        valueAnnotationData: {
          name: "",
          id: "",
          text: "",
          color: "#46B9E0",
          data: [],
        },
        equipmentData: {},
        equipmentDataList: [],
        socketQuery: {},
        annotationVisible: false,
        annotationStyle: {
          x: 0,
          y: 0,
        },
        annotationList: [],
        annotationInfo: {
          properties: { text: "", name: "" },
        },
        prePageNum: "1s",
        date: "",
        end: "",
        switchData: {},
        dragObjList: [],
        daterange: [
          moment().subtract(1, "h").format("YYYY-MM-DD HH:mm:ss"),
          moment().format("YYYY-MM-DD HH:mm:ss"),
        ],
        color: [
          "rgba(102, 145, 231)",
          "rgba(134, 92, 226)",
          "rgba(80, 195, 230)",
          "rgba(236, 156, 98)",
          "rgba(60, 146, 173)",
          "rgba(50, 246, 173)",
        ],
        upperData: {},
        lowerData: {},
        lastTime: 0,
      };
    },
    methods: {
      moment,
      prePage(prePageNum) {
        switch (prePageNum) {
          case "1s":
            return 1;
          case "5s":
            return 5;
          case "10s":
            return 10;
          case "30s":
            return 30;
          case "1m":
            return 60;
          case "5m":
            return 60 * 5;
          case "15m":
            return 60 * 15;
          case "30m":
            return 60 * 30;
          case "1h":
            return 60 * 60;
          case "6h":
            return 60 * 60 * 6;
          case "1d":
            return 60 * 60 * 24;
          case "7d":
            return 60 * 60 * 24 * 7;
          case "30d":
            return 60 * 60 * 24 * 30;
        }
      },
      delDragData(a) {
        var dyFlag = false;
        console.log(this.draglist, 0);
  
        this.draglist = this.draglist.filter((item) => {
          return a.ids + a.key != item.ids + item.key;
        });
        console.log(this.draglist, 1);
  
        this.annotationList = this.annotationList.filter((item) => {
          return a.name != item.name;
        });
        console.log(this.draglist, 2);
  
        this.draglist.map((item) => {
          if (item.dynamic_threshold_enabled) {
            dyFlag = true;
          }
        });
        this.$nextTick(() => {
          this.chartChange(dyFlag);
        });
  
        if (this.draglist.length == 0) {
          this.focusType = false;
        } else {
          this.focusType = true;
        }
      },
      dragleave(ev) {
        ev.preventDefault();
        this.focusType = false;
      },
      dragEnter(ev) {
        ev.preventDefault();
        this.focusType = true;
      },
      annotationFilter(list) {
        let result = [];
        result = list.filter((item) => {
          let i = this.dragObjList.findIndex((mea) => {
            return (
              mea.shadowId === item.shadowId &&
              item.properties.name.slice(-mea.name.length) == mea.name
            );
          });
          return (
            i > -1 &&
            item.properties.time <= moment(this.daterange[1]).valueOf() &&
            item.properties.time >= moment(this.daterange[0]).valueOf()
          );
        });
        return result;
      },
      methods7(arr) {
        return arr.filter(function (item, index, arr) {
          return arr.indexOf(item, 0) === index;
        });
      },
      updateProgress(e) {
        //e为回调回来的参数 通过进行和total的值来进行进度
        console.log(e,"/e为回调回来的参数 通过进行和total的值来进行进度")
        // this.percent = parseInt((e.loaded / e.total) * 100);
        // console.log(this.percent)
      },
      /* 测量值拖入----拖拽 */
      drop(dragObj) {
        let metric = 'AVG'//图谱数据请求状态，// LAST
        if(dragObj&&dragObj.dtype == "boolean"){
          metric = 'LAST'
        }
        if (this.draglist.length > 5) {
          ElMessage.error(this.$t('page.atlas-analysis.ChooseMaximumOf6MeasuringPoints'));
          return;
        }
        var flag = true;
        this.draglist &&
          this.draglist.map((item) => {
            if (this.equipmentData.name + dragObj.name === item.name) {
              flag = false;
            }
          });
  
        if (!flag) {
          return;
        }
        let limit = moment(this.daterange[1]).diff(
          moment(this.daterange[0]),
          "second"
        );
        let column = [];
        // if (this.draglist.length) {
        //   column.push(..._.map(this.draglist, "key"), dragObj.key);
        //   column.push(
        //     dragObj.key + "_dythreshold" + "_upper",
        //     dragObj.key + "_dythreshold" + "_lower"
        //   );
        // } else {
          /* 查询一次 */
          column.push(
            dragObj.key,
            dragObj.key + "_dythreshold" + "_upper",
            dragObj.key + "_dythreshold" + "_lower"
          );
        // }

        column = this.methods7(column);
        let paramsdata = {
          end:
            moment().diff(moment(this.daterange[1]), "minute") >= 0
              ? moment().diff(moment(this.daterange[1]), "minute") + "m"
              : "0m",
          start: moment().diff(moment(this.daterange[0]), "minute") + "m",
          interval: this.prePageNum,
          // limit: limit * 2,
          column: column,
          metric
        };
        let params = qs.stringify(paramsdata, { arrayFormat: "repeat" });
        let myChart = echarts.getInstanceByDom(
          document.getElementById("monitor")
        );
        myChart &&
          myChart.showLoading({
            text: this.$t('base.loading'),
            color: "#2C404C",
            textColor: "#000",
            maskColor: "rgba(255, 255, 255, 0.8)",
            zlevel: 0,
          });
          getWindowTimeseries(this.equipmentData.id, params, this.updateProgress)
          .then((ress) => {
            this.windowTimeseriesData = ress.payload;

            this.draglist.push({
              name: dragObj.name,
              key: dragObj.key,
              ids: this.equipmentData.id,
              unit: dragObj.unit,
              data: [],
              type: "line",
              dtype:dragObj.dtype,
              showSymbol: false,
              lineStyle: {
                //设置线条默认样式
                normal: {
                  width: 1,
                },
                //设置线条hover样式
                emphasis: {
                  // 鼠标hover上去的时候，拐点的颜色和样式
                  itemStyle: {
                    color: "#fff", //颜色
                    borderColor: "#0072FF", //图形的描边颜色
                    borderWidth: 3, // 描边的线宽
                    shadowBlur: 1, // 图形的阴影大小
                    shadowColor: "#0072FF", // 图形的阴影颜色
                  },
                },
              },
              markPoint: {
                data: [],
              },
              markLine: {
                data: [],
              },
            });
            this.windowTimeseriesData.map((item, index) => {
              this.draglist.map((s, i) => {
                s.yAxisIndex = i;
                for (let i in item) {
                  if (
                    s.key == i &&
                    s.key == dragObj.key &&
                    s.ids == this.equipmentData.id
                  ) {
                    if (
                      index == 0 &&
                      moment(item["_wend"]).valueOf() >
                        moment(this.daterange[0]).valueOf()
                    ) {
                      s.data.unshift({
                        name: moment(this.daterange[0])
                          .format("YYYY-MM-DD HH:mm:ss.SSS")
                          .valueOf(),
                        value: [
                          moment(this.daterange[0])
                            .format("YYYY-MM-DD HH:mm:ss.SSS")
                            .valueOf(),
                          "",
                          this.equipmentData.id,
                        ],
                      });
                    }
                    

                    if (
                      (moment(item["_wend"]).diff(
                        moment(this.daterange[0]),
                        "seconds"
                      ) %
                        this.prePage(this.prePageNum) ==
                      0)
                      || (moment(item["_wend"]).diff(
                        moment(this.daterange[0]),
                        "seconds"
                      ) %
                      this.prePage(this.prePageNum) >
                      0)
                    ) {
                      
                      s.data.push({
                        name: moment(item["_wend"])
                          .format("YYYY-MM-DD HH:mm:ss.SSS")
                          .valueOf(),
                        value: [
                          moment(item["_wend"])
                            .format("YYYY-MM-DD HH:mm:ss.SSS")
                            .valueOf(),
                            this.lastAvgTypeof(item[i]),
                          this.equipmentData.id,
                        ],
                      });
                    }
  
                    if (
                      index == ress.payload.length - 1 &&
                      moment(item["_wend"]).valueOf() <
                        moment(this.daterange[1]).valueOf()
                    ) {
                      s.data.push({
                        name: moment(this.daterange[1])
                          .format("YYYY-MM-DD HH:mm:ss.SSS")
                          .valueOf(),
                        value: [
                          moment(this.daterange[1])
                            .format("YYYY-MM-DD HH:mm:ss.SSS")
                            .valueOf(),
                          "",
                          this.equipmentData.id,
                        ],
                      });
                    }
                  }
                }
              });
            });
            let params = {
              type: "annotation",
              limit: 100,
              shadowId: this.equipmentData.id,
            };
            var dyFlag = false;
            getLatestReports(params)
              .then((res) => {
                this.annotationList.push(..._.get(res, ["payload"]));
                let map = new Map();
                // for (let item of this.annotationList) {
                //   if (!map.has(item.id)) {
                //     map.set(item.id, item);
                //   }
                // }
                // this.annotationList = [...map.values()];
  
                this.draglist.map((s) => {
                  if (s.dynamic_threshold_enabled) {
                    dyFlag = true;
                  }
                  _.get(res, ["payload"]).map((v) => {
                    if (s.name == _.get(v, ["properties", "name"])) {
                      if (JSON.parse(_.get(v, ["properties", "data"]))) {
                        var datax =
                          JSON.parse(_.get(v, ["properties", "data"])).data[
                            "xAxis"
                          ] ||
                          JSON.parse(_.get(v, ["properties", "data"])).data[0];
                        var datay =
                          JSON.parse(_.get(v, ["properties", "data"])).data[
                            "yAxis"
                          ] ||
                          JSON.parse(_.get(v, ["properties", "data"])).data[1];
                      }
                      s.markPoint.data.push({
                        symbol: "triangle",
                        symbolSize: 15,
                        position: "top",
                        itemStyle: {
                          color: _.get(v, ["properties", "color"]),
                        },
                        symbolOffset: [0, 0],
                        name: this.$t('page.atlas-analysis.Annotation'),
  
                        xAxis: datax,
                        yAxis: datay,
                      });
                      s.markPoint.data = s.markPoint.data.filter((item) => {
                        return item.name == this.$t('page.atlas-analysis.Annotation');
                      });
                    }
                  });
                });
  
                for (let item of this.draglist) {
                  if (!map.has(item.name)) {
                    map.set(item.name, item);
                  }
                }
                this.draglist = [...map.values()];
  
                this.$nextTick(() => {
                  this.chartChange(dyFlag);
                });
              })
              .catch(() => {
                this.$nextTick(() => {
                  spectrumEcharts({
                    chartDom: document.getElementById("monitor"),
                    dataList: this.draglist,
                    num: "1",
                  });
                });
                myChart && myChart.hideLoading();
              });
          })
          .catch(() => {
            myChart && myChart.hideLoading();
          });
      },
      /* 由于测点数据类型会有双精度值，布尔值，整数。因此需要转换 */
      lastAvgTypeof(value){
        let filterValue = null
        if(typeof value === "boolean"){
          if(value) filterValue = 1
          else filterValue = 0
        }else{
          filterValue = valueFormatter1(value)
        }
        return filterValue;
      },
      //动态阈值开关
      dyThresholdSwitch(a) {
        if(a.enabled){
        a.dynamic_threshold_enabled=false
        ElMessage.error('静态阈值开关和动态阈值开关不能同时开启');
        return
      }
        let limit = moment(this.daterange[1]).diff(
          moment(this.daterange[0]),
          "second"
        );
        let column = [];
        let ids = "";
        //   if(this.draglist.length){
        //     // column.push(..._.map(this.draglist, "key"),a.key)
        //     column.push(a.key+'_dythreshold'+'_upper',a.key+'_dythreshold'+'_lower')
        //   }else{
        //     column.push(a.key,a.key+'_dythreshold'+'_upper',a.key+'_dythreshold'+'_lower')
        //   }
        //   end: 0m;
        //   start: 60m;
        //   limit: 7200;
        //   column: measure1669881750806;
        //   column: measure1669881750806_dythreshold_upper;
        //   column: measure1669881750806_dythreshold_lower;
        //a4a15e20-714e-11ed-a28b-d3c6a50781f7
  
        this.draglist.map((item) => {
          if (a.key == item.key && a.name == item.name) {
            column.push(
              a.key,
              a.key + "_dythreshold" + "_upper",
              a.key + "_dythreshold" + "_lower"
            );
            ids = item.ids;
          }
        });
        //   measure1669881750806
        //   measure1669881750806
        let paramsdata = {
          end:
            moment().diff(moment(this.daterange[1]), "minute") >= 0
              ? moment().diff(moment(this.daterange[1]), "minute") + "m"
              : "0m",
          start: moment().diff(moment(this.daterange[0]), "minute") + "m",
          // limit: limit * 2,
          interval:  this.prePageNum,
          prePageNum: this.prePageNum,
          metric:'AVG',
          column: column,
        };
        let params = qs.stringify(paramsdata, { arrayFormat: "repeat" });
        let myChart = echarts.getInstanceByDom(
          document.getElementById("monitor")
        );
        myChart &&
          myChart.showLoading({
            text: this.$t('base.loading'),
            color: "#2C404C",
            textColor: "#000",
            maskColor: "rgba(255, 255, 255, 0.8)",
            zlevel: 0,
          });

          getWindowTimeseries(ids, params).then((ress) => {
          this.windowTimeseriesData = ress.payload;
  
          this.upperData = {
            key: a.key + "_dythreshold_upper",
            name: this.$t('page.atlas-analysis.DT'),
            yAxisIndex: a.index,
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 0,
            }, // 隐藏线
            areaStyle: {
              color: "rgba(80, 195, 230, 0.5)",
            }, // 上限区域
            data: [],
          };
          this.lowerData = {
            key: a.key + "_dythreshold_lower",
            name: this.$t('page.atlas-analysis.DT'),
            yAxisIndex: a.index,
  
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 0,
            }, //隐藏线
            areaStyle: {
              color: "rgba(80, 195, 230, 0.5)",
            }, // 下限区域
            data: [],
          };
  
          this.windowTimeseriesData.map((item) => {
            // upperData.data.push(item[upperData.key].toFixed(2))
            if (
              item[this.upperData.key] &&
              item[this.lowerData.key] &&
              moment(item["_wend"]).diff(moment(this.daterange[0]), "seconds") %
                this.prePage(this.prePageNum) ==
                0
            ) {
              this.upperData.data.push({
                name: moment(item["_wend"])
                  .format("YYYY-MM-DD HH:mm:ss.SSS")
                  .valueOf(),
                value: [
                  moment(item["_wend"]).format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(),
                  item[this.upperData.key] && item[this.upperData.key].toFixed(2),
                ],
              });
              this.lowerData.data.push({
                name: moment(item["_wend"])
                  .format("YYYY-MM-DD HH:mm:ss.SSS")
                  .valueOf(),
                value: [
                  moment(item["_wend"]).format("YYYY-MM-DD HH:mm:ss.SSS").valueOf(),
                  item[this.lowerData.key] && item[this.lowerData.key].toFixed(2),
                ],
              });
            }
          });
          this.draglist.map((s) => {
            if (a.name == s.name) {
              s.dynamic_threshold_enabled = a.dynamic_threshold_enabled;
            } else {
              s.dynamic_threshold_enabled = false;
            }
            if (a.dynamic_threshold_enabled && this.lowerData.data.length > 0) {
              this.$nextTick(() => {
                spectrumEcharts({
                  chartDom: document.getElementById("monitor"),
                  dataList: this.upperData.data
                    ? [...this.draglist, this.upperData, this.lowerData]
                    : this.draglist,
                  num: "2",
                });
              });
            } else {
              this.$nextTick(() => {
                spectrumEcharts({
                  chartDom: document.getElementById("monitor"),
                  dataList: this.draglist,
                  num: "2",
                });
              });
            }
          });
        });
      },
      //静态阈值开关
      staticSwitch(a) {
        if(a.dynamic_threshold_enabled){
        a.enabled=false
        ElMessage.error('静态阈值开关和动态阈值开关不能同时开启');
        return
      }
        var dyFlag = false;
        this.draglist.map((s) => {
          if (s.dynamic_threshold_enabled) {
            dyFlag = true;
          }
          if (a.name == s.name) {
            s.enabled = a.enabled;
          } else {
            s.enabled = false;
            s.markLine.data = [];
          }
          if (s.enabled) {
            this.dragObjList.map((item) => {
              if (item.key == s.key && s.name.indexOf(item.name) > -1)
                s.markLine.data =
                  item["operationThresholdHigh"].length > 0
                    ? [
                        {
                          name: this.$t('page.gauge_point.runnable_high'),
                          yAxis: Number(item.operationThresholdHigh),
                          label: {
                            formatter: this.$t('page.gauge_point.runnable_high'),
                          },
                          lineStyle: {
                            color: "#ED5E5E",
                          },
                        },
                        {
                          name: this.$t('page.gauge_point.runnable_low'),
                          yAxis: Number(item.operationThresholdLow),
                          label: {
                            formatter: this.$t('page.gauge_point.runnable_low'),
                          },
                          lineStyle: {
                            color: "#ED5E5E",
                          },
                        },
                        {
                          name: this.$t('page.gauge_point.ideal_high'),
                          yAxis: Number(item.standardThresholdHigh),
                          label: {
                            formatter: this.$t('page.gauge_point.ideal_high'),
                          },
                          lineStyle: {
                            color: "#13C56B",
                          },
                        },
                        {
                          name: this.$t('page.gauge_point.ideal_low'),
                          yAxis: Number(item.standardThresholdLow),
                          label: {
                            formatter: this.$t('page.gauge_point.ideal_low'),
                          },
                          lineStyle: {
                            color: "#13C56B",
                          },
                        },
                      ]
                    : [];
            });
          } else {
            s.markLine.data = [];
          }
        });
  
        this.$nextTick(() => {
          this.chartChange(dyFlag);
        });
      },
      fn1(tempArr) {
        for (let i = 0; i < tempArr.length; i++) {
          for (let j = i + 1; j < tempArr.length; j++) {
            if (
              tempArr[i].properties &&
              tempArr[j].properties &&
              tempArr[i].properties.time == tempArr[j].properties.time
            ) {
              tempArr.splice(j, 1);
              j--;
            }
          }
        }
        return tempArr;
      },
      handleImageEditor() {
        const myChart = echarts.getInstanceByDom(
          document.getElementById("monitor")
        );
        if (myChart) {
          this.imageUrl = myChart.getConnectedDataURL({
            pixelRatio: 1,
            backgroundColor: "#fff",
            type: "png",
          });
          if (this.imageUrl) {
            this.isShowImageEditor = true;
          }
        }
      },
      handleIsCollapse() {
        this.isCollapse = !this.isCollapse;
        const myChart = echarts.getInstanceByDom(
          document.getElementById("monitor")
        );
        this.$nextTick(() => {
          myChart.resize();
        });
      },
      //历史数据
      updateValueHealthData(data) {
        this.date = data.start;
        this.end = data.end;
        this.prePageNum = data.prePageNum;
        this.getValueHealthData({
          prePageNum: data.prePageNum,
          timerange: { start: data.start, end: data.end },
        });
      },
      getValueHealthData({
        prePageNum = "1s",
        timerange = { start: this.date, end: this.end },
      }) {

        let list = _.cloneDeep(this.draglist);
        list.map((s) => {
          s.data = [];
        });
        var dyFlag = false;
        this.$nextTick(()=>{

          this.draglist.map((item, index) => {
            let metric = 'AVG'//图谱数据请求状态，// LAST
            if(item&&item.dtype == "boolean"){
              metric = 'LAST'
            }
            var column = [];
            column.push(
              item.key,
              item.key + "_dythreshold" + "_upper",
              item.key + "_dythreshold" + "_lower"
            );
            let limit = moment(this.daterange[1]).diff(
              moment(this.daterange[0]),
              "second"
            );
            if (limit * 2 > 2147483647) {
              this.handleAlert("danger", "所选时间范围超出最大数据限制", 3000);
              return;
            }
            let paramsdata = {
              start: timerange.start,
              end: timerange.end,
              interval:  this.prePageNum,
              // limit: limit * 2,
              prePageNum: this.prePageNum,
              column,
              metric
            };
            let params = qs.stringify(paramsdata, { arrayFormat: "repeat" });
            let myChart = echarts.getInstanceByDom(
              document.getElementById("monitor")
            );
    
            myChart &&
              myChart.showLoading({
                text: this.$t('base.loading'),
                color: "#6691E7",
                textColor: "#000",
                maskColor: "rgba(255, 255, 255, 0.8)",
                zlevel: 0,
              });
              getWindowTimeseries(item.ids, params)
              .then((res) => {
                  if (list[index].dynamic_threshold_enabled == true) {
                    dyFlag = true;
                    this.upperData = {
                      key: list[index].key + "_dythreshold_upper",
                      name: this.$t('page.atlas-analysis.DT'),
                      type: "line",
                      smooth: true,
                      showSymbol: false,
    
                      lineStyle: {
                        width: 0,
                      }, // 隐藏线
                      areaStyle: {
                        color: "rgba(80, 195, 230, 0.5)",
                      }, // 上限区域
                      data: [],
                      yAxisIndex: index,
                    };
                    this.lowerData = {
                      key: list[index].key + "_dythreshold_lower",
                      name: this.$t('page.atlas-analysis.DT'),
    
                      type: "line",
                      smooth: true,
    
                      showSymbol: false,
                      lineStyle: {
                        width: 0,
                      }, //隐藏线
                      areaStyle: {
                        color: "rgba(80, 195, 230, 0.5)",
                      }, // 下限区域
                      data: [],
                      yAxisIndex: index,
                    };
                  }
  
                res.payload.map((item, rIndex) => {
                  for (let i in item) {
                    if (list[index].key == i) {
                      if (
                        rIndex == 0 &&
                        moment(item["_wend"]).valueOf() >
                        moment(this.daterange[0]).valueOf()
                      ) {
                        list[index].data.unshift([
                          moment(this.daterange[0]).valueOf(),
                          "",
                          this.equipmentData.id,
                        ]);
                      }
                      
                      if (
                        (moment(item["_wend"]).diff(
                          moment(this.daterange[0]),
                          "seconds"
                        ) %
                        this.prePage(prePageNum) ==
                        0)
                        || (moment(item["_wend"]).diff(
                          moment(this.daterange[0]),
                          "seconds"
                        ) %
                        this.prePage(prePageNum) >
                        0)
                      ) {
  
                        list[index].data.push({
                          name: moment(item["_wend"]).valueOf(),
                          value: [
                            moment(item["_wend"]).valueOf(),
                            this.lastAvgTypeof(item[i]),
                            this.equipmentData.id,
                          ],
                        });
                      }
                      if (
                        rIndex == res.payload.length - 1 &&
                        moment(item["_wend"]).valueOf() <
                        moment(this.daterange[1]).valueOf()
                      ) {
                        list[index].data.push({
                          name: moment(this.daterange[1]).valueOf(),
                          value: [
                            moment(this.daterange[1]).valueOf(),
                            "",
                            this.equipmentData.id,
                          ],
                        });
                      }
                    }
                  }
                  if (list[index].dynamic_threshold_enabled == true) {
                    if (
                      item[this.upperData.key] &&
                      item[this.lowerData.key] &&
                      moment(item["_wend"]).diff(
                        moment(this.daterange[0]),
                        "seconds"
                      ) %
                      this.prePage(this.prePageNum) ==
                      0
                    ) {
                      this.upperData.data.push({
                        name: moment(item["_wend"])
                          .format("YYYY-MM-DD HH:mm:ss.SSS")
                          .valueOf(),
                        value: [
                          moment(item["_wend"])
                            .format("YYYY-MM-DD HH:mm:ss.SSS")
                            .valueOf(),
                          item[this.upperData.key] &&
                          item[this.upperData.key].toFixed(2),
                        ],
                      });
                      this.lowerData.data.push({
                        name: moment(item["_wend"])
                          .format("YYYY-MM-DD HH:mm:ss.SSS")
                          .valueOf(),
                        value: [
                          moment(item["_wend"])
                            .format("YYYY-MM-DD HH:mm:ss.SSS")
                            .valueOf(),
                          item[this.lowerData.key] &&
                          item[this.lowerData.key].toFixed(2),
                        ],
                      });
                    }
                    // upperData.data.push(item[upperData.key].toFixed(2))
                  }
                });
                this.draglist = list;
                if (index == this.draglist.length - 1) {
                  this.chartChange(dyFlag);
                }
              })
              .catch((err) => {
                myChart && myChart.hideLoading();
                this.handleAlert("danger", err || this.$t('page.atlas-analysis.MapDataRequestFailed'), 3000);
              });
          });
        })
      },
      getDragCharts({ obj, data }) {
        this.dragObj = obj;
        this.equipmentData = data;
        if (this.dragObjList.length == 0) {
          this.dragObjList.push({ ...obj, shadowId: this.equipmentData.id });
        } else {
          this.dragObjList.map((item) => {
            if (item.key == obj.key && item.id == obj.id) {
              return;
            } else {
              this.dragObjList.push({ ...obj, shadowId: this.equipmentData.id });
            }
          });
        }
      },
      getValueAnnotation() {
        this.annotationVisible = false;
        let data = localStorage.getItem("valueAnnotation");
        if (JSON.parse(data)) {
          this.annotationShow = true;
          this.valueAnnotationData.name = JSON.parse(data).name;
          this.valueAnnotationData.time = JSON.parse(data).data[0];
          this.valueAnnotationData.shadowId = JSON.parse(data).data[2];
          this.valueAnnotationData.data = data;
        } else {
          ElMessage.error(this.$t('page.atlas-analysis.PleaseSelectCommentNodeLineChart'));
          this.annotationShow = false;
        }
      },
      //图谱注释
      setLatestReports() {
        this.annotationShow = false;
        var types = JSON.parse(localStorage.getItem("valueAnnotation")).type;
        localStorage.removeItem("valueAnnotation");
        var dyFlag = false;
        switch (types) {
          case "annotation":
            var params = {
              shadowId: this.valueAnnotationData.shadowId,
              type: "annotation",
              name: this.valueAnnotationData.name,
              properties: this.valueAnnotationData,
            };
            setLatestReports(params).then(() => {
              params = {
                type: "annotation",
                shadowId: this.valueAnnotationData.shadowId,
                limit: 100,
              };
              getLatestReports(params).then((res) => {
                this.annotationList.push(..._.get(res, ["payload"]));
                this.draglist.map((s) => {
                  if (s.dynamic_threshold_enabled) {
                    dyFlag = true;
                  }
                  _.get(res, ["payload"]).map((v) => {
                    if (s.name == _.get(v, ["properties", "name"])) {
                      if (JSON.parse(_.get(v, ["properties", "data"]))) {
                        var datax =
                          JSON.parse(_.get(v, ["properties", "data"])).data[
                            "xAxis"
                          ] ||
                          JSON.parse(_.get(v, ["properties", "data"])).data[0];
                        var datay =
                          JSON.parse(_.get(v, ["properties", "data"])).data[
                            "yAxis"
                          ] ||
                          JSON.parse(_.get(v, ["properties", "data"])).data[1];
                      }
                      s.markPoint.data.push({
                        symbol: "triangle",
                        symbolSize: 15,
                        position: "top",
                        itemStyle: {
                          color: _.get(v, ["properties", "color"]),
                        },
                        symbolOffset: [0, 0],
                        name: this.$t('page.atlas-analysis.Annotation'),
                        xAxis: datax,
                        yAxis: datay,
                      });
                      s.markPoint.data = s.markPoint.data.filter((item) => {
                        return item.name == this.$t('page.atlas-analysis.Annotation');
                      });
                    }
                  });
                });
                localStorage.removeItem("valueAnnotation");
                this.$nextTick(() => {
                  this.chartChange(dyFlag);
                });
              });
              // this.drop();
            });
            break;
          case "chooseSeries":
            /* _.get(this.equipmentData, ["attributes", "measurements"]).map(
              (item) => {
                if (this.valueAnnotationData.name == item.name) {
                  this.valueAnnotationData.id = item.id;
                }
              }
            ); */
            params = {
              shadowId: this.valueAnnotationData.shadowId,
              type: "annotation",
              name: this.valueAnnotationData.name,
              properties: this.valueAnnotationData,
            };
            setLatestReports(params).then(() => {
              params = {
                type: "annotation",
                shadowId: this.valueAnnotationData.shadowId,
                limit: 100,
              };
              getLatestReports(params).then((res) => {
                this.annotationList.push(..._.get(res, ["payload"]));
                this.draglist.map((s) => {
                  if (s.dynamic_threshold_enabled) {
                    dyFlag = true;
                  }
                  this.annotationList.map((v) => {
                    if (s.name == _.get(v, ["properties", "name"])) {
                      var xData =
                        _.get(v, ["properties", "data"]) &&
                        JSON.parse(_.get(v, ["properties", "data"])).data[0];
                      var yData =
                        _.get(v, ["properties", "data"]) &&
                        JSON.parse(_.get(v, ["properties", "data"])).data[1];
                      s.markPoint.data.push({
                        symbol: "triangle",
                        symbolSize: 15,
                        position: "top",
                        itemStyle: {
                          color: _.get(v, ["properties", "color"]),
                        },
                        symbolOffset: [0, 0],
                        name: this.$t('page.atlas-analysis.Annotation'),
                        xAxis: xData,
                        yAxis: yData,
                      });
                      s.markPoint.data = s.markPoint.data.filter((item) => {
                        return item.name == this.$t('page.atlas-analysis.Annotation');
                      });
                    }
                  });
                });
                this.$nextTick(() => {
                  this.chartChange(dyFlag);
                });
              });
            });
            break;
          default:
            break;
        }
      },
      //删除注释
      delLatestReports(obj) {
        var dyFlag = false;
        delLatestReports(obj.id).then(() => {
          this.annotationVisible = false;
          this.valueAnnotationDataIndex = 0;
          let params = {
            type: "annotation",
            shadowId: this.valueAnnotationData.shadowId,
            limit: 100,
          };
          getLatestReports(params).then((res) => {
            this.annotationList.push(..._.get(res, ["payload"]));
            this.draglist.map((s) => {
              if (s.dynamic_threshold_enabled) {
                dyFlag = true;
              }
              s.markPoint.data = [];
              this.annotationList.map((v) => {
                if (s.name == _.get(v, ["properties", "name"])) {
                  var xData =
                    _.get(v, ["properties", "data"]) &&
                    JSON.parse(_.get(v, ["properties", "data"])).data[0];
                  var yData =
                    _.get(v, ["properties", "data"]) &&
                    JSON.parse(_.get(v, ["properties", "data"])).data[1];
                  s.markPoint.data.push({
                    symbol: "triangle",
                    symbolSize: 15,
                    position: "top",
                    itemStyle: {
                      color: _.get(v, ["properties", "color"]),
                    },
                    symbolOffset: [0, 0],
                    name: this.$t('page.atlas-analysis.Annotation'),
                    xAxis: xData,
                    yAxis: yData,
                  });
                  s.markPoint.data = s.markPoint.data.filter((item) => {
                    return item.name == this.$t('page.atlas-analysis.Annotation');
                  });
                }
              });
            });
            this.$nextTick(() => {
              this.chartChange(dyFlag);
            });
          });
        });
      },
      delLocal() {
        this.annotationVisible = false;
        localStorage.removeItem("valueAnnotation");
      },
      handleAlert(
        variant = "danger",
        message = "",
        icon = "ri-error-warning-line",
        duration = "3000"
      ) {
        this.formValidataAlert = true;
        this.alertInfo.variant = variant;
        this.alertInfo.icon = icon;
        if (message) {
          this.alertInfo.content = message;
        }
        setTimeout(() => {
          this.formValidataAlert = false;
        }, duration);
      },
      timeRanges(DateStr, beginDateStr, endDateStr) {
        var curDate = new Date(DateStr),
          beginDate = new Date(beginDateStr),
          endDate = new Date(endDateStr);
        if (curDate >= beginDate && curDate <= endDate) {
          return true;
        }
        return false;
      },
      chartChange(type) {
        if (type) {
          spectrumEcharts({
            chartDom: document.getElementById("monitor"),
            dataList: this.upperData.data
              ? [...this.draglist, this.upperData, this.lowerData]
              : this.draglist,
            title: this.draglist.length
              ? {}
              : {
                  text: this.$t('page.atlas-analysis.PleasePlaceLeft'),
                  left: "center",
                  top: "center",
                  textStyle: {
                    color: "#212529",
                    fontSize: 24,
                    fontWeight: 400,
                  },
                },
          });
        } else {
          spectrumEcharts({
            chartDom: document.getElementById("monitor"),
            dataList: this.draglist,
            title: this.draglist.length
              ? {}
              : {
                  text: this.$t('page.atlas-analysis.PleasePlaceLeft'),
                  left: "center",
                  top: "center",
                  textStyle: {
                    color: "#212529",
                    fontSize: 24,
                    fontWeight: 400,
                  },
                },
          });
        }
      },
    },
    computed: {
      notesListData() {
        var list = [];
        var daterange = JSON.parse(localStorage.getItem("daterange")) || [
          moment().subtract(1, "h").format("YYYY-MM-DD HH:mm:ss"),
          moment().format("YYYY-MM-DD HH:mm:ss"),
        ];
        this.annotationList.filter((item) => {
          this.draglist.map((items) => {
            if (item.name == items.name) {
              list.push(item);
            }
          });
        });
        list = list.filter((item) => {
          return this.timeRanges(
            JSON.parse(item.properties.data).data[0],
            daterange[0],
            daterange[1]
          );
        });
        localStorage.removeItem("daterange");
        var result = [];
        var obj = {};
        for (var i = 0; i < list.length; i++) {
          if (!obj[list[i].createdAt]) {
            result.push(list[i]);
            obj[list[i].createdAt] = true;
          }
        }

        return result;
      },
    },
    beforeUnmount() {
      localStorage.removeItem("historyData");
    },
    mounted() {
      localStorage.removeItem("valueAnnotation");
      localStorage.removeItem("dataZoom");
      // spectrumEcharts({
      //     chartDom: document.getElementById("monitor"),
      //     dataList: [],
      //     title:{
      //         text:"请先在左侧拖拽测点放置于此。",
      //         left:"center",
      //         top:"center",
      //         textStyle:{
      //           color:"#212529",
      //           fontSize:24,
      //           fontWeight:400
      //         }
      //     }
      //   });
      var historyData = JSON.parse(localStorage.getItem("historyData"));
      var equipmentData = JSON.parse(localStorage.getItem("equipmentData"));
      /* var start = this.$route.query.start;
      var end = this.$route.query.end; */
      /* if(this.$route.query.startTime && this.$route.query.endTime){
        this.daterange[0] = moment(this.$route.query.startTime).format("YYYY-MM-DD HH:mm:ss")
        this.daterange[1] = moment(this.$route.query.endTime).format("YYYY-MM-DD HH:mm:ss")
      } */

      if (historyData && equipmentData) {
        this.equipmentData = equipmentData;
        historyData.map((item) => {
          this.getDragCharts({ obj: item, data: equipmentData })
          // this.dragObj = item;
          this.drop(this.dragObj);
        });
      }
      window.addEventListener("setItemEvent", (e) => {
        let data = JSON.parse(e.newValue);
        //获取当前时间的时间戳
        let now = new Date().valueOf();
        //第一次点击
        if (this.lastTime == 0) {
          console.log('触发事件');
          this.lastTime = now;
        } else {
          if (now - this.lastTime > 2000) {
            this.lastTime = now;
            console.log('间隔大于2秒，触发方法');
            //添加自己要调用的方法
            switch (data.type) {
              case "annotation":
                this.annotationStyle = {
                  x: data.offsetX,
                  y: data.offsetY,
                };
                this.draglist.map((items, index) => {
                  var params = {
                    type: "annotation",
                    shadowId: items.ids,
                    limit: 100,
                  };
                  getLatestReports(params).then((res) => {
                    this.annotationVisible = true;
                    this.valueAnnotationDataList=[]
                    _.get(res, ["payload"]).map((item) => {
                      if (JSON.parse(_.get(item, ["properties", "data"]))) {
                        var datax = JSON.parse(
                          _.get(item, ["properties", "data"])
                        ).data[0];
                        var datay = JSON.parse(
                          _.get(item, ["properties", "data"])
                        ).data[1];
                      }
                      if (data.data[1] == datay && data.data[0] == datax) {
                        localStorage.setItem(
                          "valueAnnotation",
                          _.get(item, ["properties", "data"])
                        );
                        this.annotationInfo = item;
                        // this.valueAnnotationData = _.get(item, ["properties"]);
                        this.valueAnnotationDataList.push(item);
                        this.valueAnnotationData = {
                          name: "",
                          shadowId: JSON.parse(
                            _.get(item, ["properties", "data"])
                          ).shadowId,
                          text: "",
                          color: "#46B9E0",
                          data: [],
                        };
                      }
                    });
                    if (index == this.draglist.length - 1) {
                      var dyFlag = false;
                      this.draglist.map((item) => {
                        if (item.dynamic_threshold_enabled) {
                          dyFlag = true;
                        }
                      });
                      this.$nextTick(() => {
                        this.chartChange(dyFlag);
                      });
                    }
                  });
                });
                break;
              case "chooseSeries":
                this.valueAnnotationData = {
                  name: "",
                  shadowId: "",
                  text: "",
                  color: "#46B9E0",
                  data: [],
                };
                var dyFlag = false;
                this.draglist.map((item) => {
                  if (item.dynamic_threshold_enabled) {
                    dyFlag = true;
                  }
                });
                this.$nextTick(() => {
                  this.chartChange(dyFlag);
                });
                break;
              default:
                break;
            }
          } else {
            console.log("不触发");
          }
        }
      });
    },
  };
  </script>
  <style lang="scss" scoped>
  :deep(.el-color-picker__color-inner) {
    clip-path: polygon(50% 0px, 100% 100%, 0px 100%);
  }
  :deep(.el-color-picker__color) {
    border: none;
  }
  :deep(.el-color-picker__trigger) {
    border-color: #ced4da;
  }
  .dotted_css {
    border: 3px rgb(19, 178, 241) dotted !important;
  }
  .mytext-gradient {
    background: linear-gradient(89.23deg, #65b8d6 20.69%, #464c96 76.4%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  :deep(.btn){
    border:none !important;
  }
  </style>
  